import { getRequest,  putRequest } from '../../services/httpService';
import {  OocyteRetrievalType, semenProcessingType, StimulationChart } from './CycleOverviewReport/CycleOverviewReportHelper';
import { EmbryoTransferDetail } from './EmbryoTransferOutcome/EmbryoTransferOutcomeHelper';


export interface OocyteSource {
  first_name: string;
  last_name: string;
  medical_record_no: string;
  photo: string;
}

export interface SpermSource {
  first_name: string;
  last_name: string;
  medical_record_no: string;
  photo: string;
}

export interface Recipient {
  first_name: string;
  last_name: string;
  medical_record_no: string;
  photo: string;
}

export interface DonorInfo {
  oocyte_source: OocyteSource[];
  sperm_source: SpermSource[];
  recipient: Recipient | null;
  surrogate: string | null;
}

export interface CycleProcedure {
  id: number;
  services: number[];
  procedures: string;
  procedures_type: string;
  procedure_notes: string | null;
  created_on: string;
  donor_info: DonorInfo | null;
  indication: string;
  indication_label?: string;
  procedure_overview_links:string

}

export interface CycleService {
  id: number;
  name: string;
  code: string;
  description: string;
  service_type: 'CYCLE_RELATED' | 'OTHER_TYPE' | string;
}


export interface CycleStepStatus {
  action: string;
  is_completed: boolean;
}

export interface CycleDetailsType {
  id: number;
  cycle_number: string;
  cycle_name: string;
  cycle_name_label?: string | null;
  procedure: CycleProcedure;
  medication_protocol?: number;
  medication_protocol_name: string| null;
  medication_protocol_name_label?: string | null;
  cycle_provider: number;
  provider_name: string;
  cycle_coordinator: number;
  coordinator_name: string;
  cycle_creator: number;
  cycle_start_date: string;
  cycle_end_date: string;
  lmp_date: string;
  cycle_creator_name: string;
  is_surrogate: boolean;
  cycle_warning: string;
  remarks: string | null;
  status: string;
  patient: number;
  patient_name: string;
  stimulation_chart?: StimulationChart | null; 
  services:CycleService[] | null;
  opu_status: boolean;
  semen_processing_status: boolean;
  stim_status: boolean;
  embryo_trasfer_status: boolean;
  fertilization_status: boolean;
  embryo_culture_status: boolean;
  procedure_overview_links:CycleStepStatus[]
  semen_processing?: semenProcessingType[];
  oocyte_retrievals?:OocyteRetrievalType[];
  embryo_transfer_details?: EmbryoTransferDetail[];
  is_editable?: boolean;
}


export function getcycleListUrl(Id: string): string {
  return `/cycle/${Id}/`; 
}


export function updateDatesUrl(Id: string): string {
  return `/cycle/${Id}/edit-dates`;
}

export function getcycleOverviewReportUrl(Id: string, cycleId: string): string {
  return `cycle/treatment-report/patient/${Id}/?cycle_id=${cycleId}`;
}

export function getcycleOverviewReport(Id: string, cycleId: string): Promise<CycleDetailsType> {
  return getRequest(getcycleOverviewReportUrl(Id, cycleId), { responseType: 'json' });
}

export function getcycleList(Id: string): Promise<CycleDetailsType> {
  return getRequest(getcycleListUrl(Id), { responseType: 'json' });
}

export function updateDates(Id: string, payload: Partial<Pick<CycleDetailsType, 'cycle_start_date' | 'cycle_end_date' | 'lmp_date' | 'medication_protocol'>>): Promise<CycleDetailsType> {
  return putRequest(updateDatesUrl(Id), payload, { responseType: 'json' });
}

export interface steps{
  step:string,
  status:boolean
};
